import React, { useEffect, useState } from 'react';
import { Spin, Empty } from 'antd';
import { generate_batch_parameter_report } from '@/utils/api';

/**
 * Monitoring report — this report is generated as a graph-based PDF on the
 * backend (matplotlib/reportlab), so there is no HTML to render. We preview the
 * base64 PDF in an iframe (the browser's PDF viewer provides print/download).
 */
const MonitoringReport = ({ batchNumber }) => {
  const [pdf, setPdf] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!batchNumber) return;
    let active = true;
    setLoading(true);
    setError('');
    setPdf('');
    generate_batch_parameter_report({ batch_number: batchNumber }, (res) => {
      if (!active) return;
      if (res?.data?.status === 'success' && res?.data?.data) {
        setPdf(`data:application/pdf;base64,${res.data.data}`);
      } else {
        setError(res?.data?.message || 'No report data available');
      }
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, [batchNumber]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
        <Spin size="large" tip="Generating report…" />
      </div>
    );
  }
  if (error || !pdf) {
    return <Empty description={error || 'No report'} style={{ padding: 60 }} />;
  }

  return (
    <div className="p-4">
      <iframe
        title="Monitoring Report"
        src={pdf}
        className="w-full border rounded-lg bg-white"
        style={{ height: '780px' }}
      />
    </div>
  );
};

export default MonitoringReport;
